export class RegisterModel {
    FirstName: string = "";
    LastName: string = "";
    Email: string = "";
    Password: string = "";
    ConfirmPassword: string = "";
    TermsAgree: boolean = false;
    Source: number = 1;
}


// WEBPACK FOOTER //
// ./app/objects/users/registerModel.ts